export default "__VITE_ASSET__f2ec1175__"